import React from 'react';
import classNames from 'classnames';
import { ESignature } from './eSignature';

import { usePurchaseContext } from 'QuoteApp/services/providers';

import styles from './styles.module.css';

type AgentSignatureContentType = {
  policyDocumentsSigned: boolean;
  documentSigningHandledByAgent: boolean;
  disableAgentSignatures: boolean;
};

export const AgentSignatureContent = (props: AgentSignatureContentType) => {
  const {
    policyDocumentsSigned,
    documentSigningHandledByAgent,
    disableAgentSignatures,
  } = props;

  const {
    eSignatureSMSConsent,
    setESignatureSMSConsent,
  } = usePurchaseContext();

  return (
    <div
      className={classNames(
        styles.wrapper,
        disableAgentSignatures && styles.compactWrapper
      )}
    >
      <div className={styles.mainSection}>
        <ESignature
          policyDocumentsSigned={policyDocumentsSigned}
          eSignatureSMSConsent={eSignatureSMSConsent}
          documentSigningHandledByAgent={documentSigningHandledByAgent}
          setESignatureSMSConsent={setESignatureSMSConsent}
          disableAgentSignatures={disableAgentSignatures}
        />
      </div>
    </div>
  );
};
